// Auth API — typed-обёртки над 4 endpoints /api/auth/*.
// Контракты синхронизированы с backend Java records (LoginRequest/Response, RefreshRequest, AuthService.CurrentUserView).

import { apiClient } from './client';

/** Тело запроса для login. */
export interface LoginRequest {
  username: string;
  password: string;
}

/** Тело ответа login/refresh. */
export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  expiresIn: number;
}

/** Роль пользователя (вложенный record). */
export interface RoleView {
  id: string;
  code: string;
  displayName: string;
}

/** Департамент пользователя (вложенный record). */
export interface DepartmentView {
  id: string;
  name: string;
  code: string;
  roleInDepartment: string;
}

/** Ответ /api/auth/me. */
export interface CurrentUserView {
  id: string;
  username: string;
  email: string;
  displayName: string;
  status: string;
  roles: RoleView[];
  departments: DepartmentView[];
  createdAt: string;
  updatedAt: string;
}

/** Typed-обёртки над auth endpoints. */
export const authApi = {
  /** POST /api/auth/login. */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/api/auth/login', credentials);
    return data;
  },

  /** POST /api/auth/refresh. */
  async refresh(refreshToken: string): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/api/auth/refresh', { refreshToken });
    return data;
  },

  /** POST /api/auth/logout. */
  async logout(): Promise<void> {
    await apiClient.post('/api/auth/logout');
  },

  /** GET /api/auth/me. */
  async me(): Promise<CurrentUserView> {
    const { data } = await apiClient.get<CurrentUserView>('/api/auth/me');
    return data;
  },
};
